import React from 'react';

import { useSalesOrdersActivity_TabBarQuery } from 'generated/graphql';
import { tableUtil } from 'modules';
import * as types from '../types';



export interface IData {
  newSalesOrdersCount: number;
  awaitingApprovalCount: number;
  awaitingFulfillmentCount: number;
  awaitingPaymentCount: number;
  inTransitCount: number;
}

export function useQuery(filter: types.IFilter) {
  const tuple = useSalesOrdersActivity_TabBarQuery({
    variables: {
      salesChannelName: filter.salesChannel,
      storeId: filter.storeId || undefined, // empty string if not selected, but server requires UUID string.
      searchText: filter.searchText,
      after: filter.after.toISO()
    }
  });

  tableUtil.useRefetchOverInterval(tuple, 5000);

  return React.useMemo(
    () => {
      const data: IData = {
        newSalesOrdersCount: tuple.data?.newOrders ?? 0,
        awaitingApprovalCount: tuple.data?.awaitingApproval ?? 0,
        awaitingFulfillmentCount: tuple.data?.awaitingFulfillment ?? 0,
        awaitingPaymentCount: tuple.data?.awaitingPayment ?? 0,
        inTransitCount: tuple.data?.inTransit ?? 0
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
